import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './styles/App.css';

const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      portfolio: 'Portfolio',
      testimonials: 'Testimonials',
      blog: 'Blog',
      contact: 'Contact'
    },
    hero: {
      title: 'Zezo',
      subtitle: 'Driving Growth with Futuristic Marketing',
      description: 'Transform your digital presence with cutting-edge marketing strategies that deliver exceptional ROI and sustainable growth.',
      cta1: 'Work With Zezo',
      cta2: 'Explore Services',
      stats: {
        clients: 'Happy Clients',
        roi: 'Average ROI',
        campaigns: 'Successful Campaigns'
      }
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'نبذة',
      services: 'الخدمات',
      portfolio: 'الأعمال',
      testimonials: 'التوصيات',
      blog: 'المدونة',
      contact: 'التواصل'
    },
    hero: {
      title: 'زيزو',
      subtitle: 'قيادة النمو بالتسويق المستقبلي',
      description: 'حول حضورك الرقمي باستراتيجيات تسويقية متطورة تحقق عائد استثماري مميز ونمو مستدام.',
      cta1: 'اعمل مع زيزو',
      cta2: 'استكشف الخدمات',
      stats: {
        clients: 'عميل سعيد',
        roi: 'متوسط العائد',
        campaigns: 'حملة ناجحة'
      }
    }
  }
};

function App() {
  const [language, setLanguage] = useState('en');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    document.body.className = `dark-mode ${language === 'ar' ? 'rtl' : 'ltr'}`;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  const toggleLanguage = () => setLanguage(language === 'en' ? 'ar' : 'en');

  if (isLoading) {
    return (
      <div className="loading-screen">
        <motion.div
          className="loading-logo"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <div className="neon-text gradient-text">Z</div>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="futuristic-bg"></div>
      <Navbar 
        language={language}
        translations={translations[language]}
        toggleLanguage={toggleLanguage}
      />
      <Hero translations={translations[language]} language={language} />
      <About translations={translations[language]} language={language} />
      <Services translations={translations[language]} language={language} />
      <Portfolio translations={translations[language]} language={language} />
      <Testimonials translations={translations[language]} language={language} />
      <Blog translations={translations[language]} language={language} />
      <Contact translations={translations[language]} language={language} />
      <Footer translations={translations[language]} language={language} />
    </div>
  );
}

export default App;